import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/ContextData';
import MobMoreProducts from '../components/MobMoreProducts';

const MobProductTab = () => {
    const navigate = useNavigate();
    const { demo, dealerId, setDealerId } = useAuth()

    const url = window.location.pathname.split("/")
    const product = url[1]
    const breadcrum = url[2] && url[2].toUpperCase().replace(/-/g, ' ')
    const [searchParams] = useSearchParams();

    // const dealerId = searchParams.get('dealerId') || localStorage.getItem("dealerId")
    const sid = searchParams.get('sid')

    const [stylesData, setStylesData] = useState([])
    const [typesData, setTypesData] = useState([])
    const [collectionsData, setCollectionsData] = useState([])

    const [seoData, setSeoData] = useState("")

    const [data, setData] = useState([])
    const [priceData, setPriceData] = useState([])
    const [page, setPage] = useState(1)
    const [pages, setPages] = useState()

    const [loader, setLoader] = useState(false)

    const loadMore = () => {
        setPage(page + 1)
    }

    // ---------------------- Get Data -------------------------
    useEffect(() => {
        setLoader(true);
        var myHeaders = new Headers();
        myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            product_name: product.toUpperCase().replace(/-/g, ' '),
            sid: !sid ? "" : sid,
            dealerId: dealerId
        })

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        fetch(process.env.REACT_APP_URL + "customer/items?page=" + page, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "success") {
                    setLoader(false)
                    setData(result.data);
                    setPages(result.pages);
                    setPriceData(result.pricedata);
                    setSeoData(result.seoData);
                    setStylesData(result.styles);
                    setTypesData(result.types);
                    setCollectionsData(result.collections);
                }
            })
            .catch(error => console.log('error', error));
    }, [dealerId, product, sid, page])


    const currentUrl = window.location.pathname.replace("/", "")

    useEffect(() => {
        if (!demo) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "url": currentUrl
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/dealerUrl", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        localStorage.setItem("dealerId", result.data.dealerId);
                        localStorage.setItem("storeName", result.data.storeName);
                        setDealerId(result.data.dealerId)
                        navigate("/")
                    }
                })
                .catch(error => console.log('error', error));
        }

    }, [dealerId, currentUrl, demo, navigate, setDealerId]);

    const [isTab, setIsTab] = useState("")

    useEffect(() => {
        if (seoData) {
            setIsTab(seoData.style_name ? "type" : seoData.type_name ? "type" : seoData.collection_name ? "collection" : "style")
        }
    }, [seoData])


    return (
        <React.Fragment>
            {seoData &&
                <Helmet>
                    {/* Page Information */}
                    <title>{seoData.metaTitle + "| Wallicon"}</title>
                    {/* <meta name="description" content={seoData.metaDescription} />
                    <meta name="keywords" content={seoData.metaKeywords && seoData.metaKeywords.toString().replace(/ ,/g, ',')} /> */}

                    {/* Google / Search Engine Tags  */}
                    {/* <meta name="robots" content="max-image-preview:large" />
                    <meta name="robots" content="index, follow" /> */}
                    {/* <link rel="canonical" href="https://wallicon.in" /> */}
                    {/* <meta itemprop="name" content={seoData.metaTitle + "| Wallicon"} />
                    <meta itemprop="description" concontent={seoData.metaDescription} />
                    <meta itemprop="image" content={process.env.REACT_APP_URL + seoData.logo} /> */}

                    {/* Facebook Meta Tags  */}
                    {/* <meta property="og:url" content={window.location.href} />
                    <meta property="og:locale" content="en_IN" />
                    <meta property="og:site_name" content="Wallicon" />
                    <meta property="og:type" content="website" />
                    <meta property="og:title" content={seoData.metaTitle + "| Wallicon"} />
                    <meta property="og:description" concontent={seoData.metaDescription} />
                    <meta property="og:image" content={process.env.REACT_APP_URL + seoData.logo} />
                    <meta property="og:image:secure_url" content={process.env.REACT_APP_URL + seoData.logo} />
                    <meta property="og:image:width" content="760" />
                    <meta property="og:image:height" content="407" /> */}

                    {/* Twitter Meta Tags  */}
                    {/* <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:domain" content="wallicon.in" />
                    <meta name="twitter:title" content={seoData.metaTitle + "| Wallicon"} />
                    <meta name="twitter:description"
                        concontent={seoData.metaDescription} />
                    <meta name="twitter:image" content={process.env.REACT_APP_URL + seoData.logo} />
                    <meta name="twitter:image:alt" content={seoData.metaTitle + "| Wallicon"} />
                    <meta name="twitter:site" content="@wallicon" />
                    <meta name="twitter:creator" content="@wallicon" /> */}
                </Helmet>
            }
            <div className="mainWidth">
                <Row className="tw_center mt-2 border-bottom border-2 mx-0">
                    <Col >
                        <div className={`mouse fs20 ${isTab === "style" ? 'cpm border-bottom border-3 border-dark W_fit' : ''}`} onClick={() => { setIsTab("style"); }}>Style</div>
                    </Col>
                    <Col >
                        <div className={`mouse fs20 ${isTab === "type" ? 'cpm border-bottom border-3 border-dark W_fit' : ''}`} onClick={() => setIsTab("type")}>Type</div>
                    </Col>
                    <Col>
                        <div className={`mouse fs20 ${isTab === "collection" ? 'cpm border-bottom border-3 border-dark W_fit' : ''}`} onClick={() => { setIsTab("collection"); }}>Collections</div>
                    </Col>
                </Row>

                {
                    isTab === "style" ?
                        <>
                            <div className='productTabSlider'>
                                {stylesData.map((item, index) => (
                                    <div
                                        key={index}
                                        className="tw_center mouse text-dark "
                                        onClick={() => {
                                            navigate("/" + product + "/" + item.style_name.toLowerCase().replace(/\s/g, '-') + "?sid=" + item._id + (dealerId && "&dealerId=" + dealerId))
                                        }}
                                    >
                                        <img src={process.env.REACT_APP_S3URL + item.logo} className=" cataIConsCS rounded-3 p-2" alt={item.style_name} />
                                        <p className="descText text-center wmx w-100 mt-1">{item.style_name}</p>
                                    </div>
                                ))}
                            </div>
                            {loader === true ? <div className="moreDataLoader">
                                <img src="/assets/icons/wallicon.gif" alt="loader" />
                            </div> :
                                <MobMoreProducts breadcrum={breadcrum} title={product.toUpperCase().replace(/-/g, ' ')} loadMore={loadMore} page={page} setPage={setPage} pages={pages} data={data} priceData={priceData} />
                            }
                        </>
                        :
                        isTab === "type" ?
                            <>
                                <div className='productTabSlider'>
                                    {typesData.map((item, index) => (
                                        <div
                                            key={index}
                                            className="tw_center mouse text-dark"
                                            onClick={() => {
                                                navigate("/" + product + "/" + item.type_name.toLowerCase().replace(/\s/g, '-') + "?sid=" + item._id + (dealerId && "&dealerId=" + dealerId))
                                            }}
                                        >
                                            <img src={process.env.REACT_APP_S3URL + item.logo} className=" cataIConsCS rounded-3 p-2" alt={item.type_name} />
                                            <p className="descText text-center wmx w-100 mt-1">{item.type_name}</p>
                                        </div>
                                    ))}
                                </div>
                                {loader === true ? <div className="moreDataLoader">
                                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                                </div> :
                                    <MobMoreProducts breadcrum={breadcrum} title={product.toUpperCase().replace(/-/g, ' ')} loadMore={loadMore} page={page} setPage={setPage} pages={pages} data={data} priceData={priceData} />
                                }
                            </>
                            : isTab === "collection" ?
                                <>
                                    <div className='productTabSlider'>
                                        {collectionsData.map((item, index) => (
                                            <div
                                                key={index}
                                                className="tw_center mouse text-dark"
                                                onClick={() => {
                                                    navigate("/" + product + "/" + item.collection_name.toLowerCase().replace(/\s/g, '-') + "?sid=" + item._id + (dealerId && "&dealerId=" + dealerId))
                                                }}
                                            >
                                                <img src={process.env.REACT_APP_S3URL + item.logo} className=" cataIConsCS rounded-3 p-2" alt={item.collection_name} />
                                                <p className="descText text-center wmx w-100 mt-1">{item.collection_name}</p>
                                            </div>
                                        ))}
                                    </div>
                                    {loader === true ? <div className="moreDataLoader">
                                        <img src="/assets/icons/wallicon.gif" alt="loader" />
                                    </div> :
                                        <MobMoreProducts breadcrum={breadcrum} title={product.toUpperCase().replace(/-/g, ' ')} loadMore={loadMore} page={page} setPage={setPage} pages={pages} data={data} priceData={priceData} />
                                    }
                                </>
                                : <div className="moreDataLoader">
                                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                                </div>

                }
            </div>
        </React.Fragment>
    )
}

export default MobProductTab
